import { Injectable } from '@angular/core';

/**
 * Coordinates state across multiple AdaptiveTooltipDirective instances.
 * Ensures that opening one tooltip resets the previously opened one,
 * so the next click on the previous element starts the two-tap pattern from scratch.
 */
@Injectable({ providedIn: 'root' })
export class AdaptiveTooltipCoordinator {
	private active: { reset: () => void } | null = null;

	/**
	 * Marks the given handler as the currently active tooltip.
	 * If another tooltip was active before, it will be reset.
	 */
	public setActive(handler: { reset: () => void }): void {
		if (this.active && this.active !== handler) {
			this.active.reset();
		}
		this.active = handler;
	}

	/**
	 * Clears the active tooltip if it matches the given handler.
	 */
	public clear(handler: { reset: () => void }): void {
		if (this.active === handler) {
			this.active = null;
		}
	}
}
